module.exports = __webpack_public_path__ + "media/graphic1/Grain-Blue-BG-1ea2df84.png";